import React from "react";
import * as constants from '../constants';
import CPSettingToggle from "../../../../UI/Settings/CPSettingToggle";
import CPSettingSize from "../../../../UI/Settings/CPSettingSize";

const CardViewList = ({settings, onChange}) => {
    return (
        <>
            <CPSettingToggle
                name={constants.SCHEDULE_LIST_SHOW_DESCRIPTION}
                isChecked={settings?.[constants.SCHEDULE_LIST_SHOW_DESCRIPTION]}
                label="Разворачивать описание всех докладов по умолчанию"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_LIST_SHOW_MEMBERS_PHOTO}
                isChecked={settings?.[constants.SCHEDULE_LIST_SHOW_MEMBERS_PHOTO]}
                label="Показывать фотографии участников"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_LIST_SHOW_MEMBERS_NAME}
                isChecked={settings?.[constants.SCHEDULE_LIST_SHOW_MEMBERS_NAME]}
                label="Показывать имена участников"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_LIST_SHOW_PARTICIPATION_TYPE}
                isChecked={settings?.[constants.SCHEDULE_LIST_SHOW_PARTICIPATION_TYPE]}
                label="Показывать формат"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_LIST_SHOW_STATUS}
                isChecked={settings?.[constants.SCHEDULE_LIST_SHOW_STATUS]}
                label="Показывать статус"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_LIST_ADD_TO_CALENDAR}
                isChecked={settings?.[constants.SCHEDULE_LIST_ADD_TO_CALENDAR]}
                label="Показывать кнопку 'Добавить в календарь'"
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.SCHEDULE_LIST_PHOTO_ROUNDING}
                label="Скругление фотографий в карточках"
                eventValue={settings?.[constants.SCHEDULE_LIST_PHOTO_ROUNDING]}
                defaultValue={'10px'}
                onChange={onChange}
            />
        </>
    );
};

export default CardViewList;
